import React from "react";

const IconCheckMarkNoCircle = (props?: { iconFill?: string, className?: string, defs?: React.ReactNode }) => {
    return (
        <svg
            className={props?.className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            {props?.defs ? props.defs : null}
            <path
                style={{fill: props?.iconFill}}
                d="M9 22-1 11.402l2.798-2.859 7.149 7.473L22.091 2 25 4.806z"></path>
        </svg>
    )
};

export default IconCheckMarkNoCircle;
